import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const GetMailTypes = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.mail_types
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCountryList = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.countries
  };

  return axios(requestOptions)
    .then(res => res.data);
}

// export const GetStateList = (id) => {
//   let requestOptions = {
//     method: 'GET',
//     url: `${urls.countries}/${id}/states`
//   };

//   return axios(requestOptions)
//     .then(res => res.data);
// }

export const GetCountryData = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.countries}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetCurrencyList = () => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.currency}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetProvider = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.provider,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateProvider = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.clients}/${data.id}`,
    data: {
      client: data.params
    },
    // paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateProviderLogo = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.clients}/${data.id}`,
    data: data.params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetClientFeatures = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.client_features
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetScheme = () => {
  const requestOptions = {
    method: 'GET',
    // url: urls.admin.color_scheme
    url: urls.color_scheme
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const SetScheme = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: urls.admin.color_scheme,
    data
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetProviderFeatures = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.features
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateProviderFeatures = (features) => {
  const requestOptions = {
    method: 'PUT',
    url: urls.admin.features,
    data: features
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const GetProviderPricesLists = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.operator_prices_lists}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateProviderPricesLists = (id , prices) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.operator_prices_lists}/${id}`,
    data: prices
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const GetCustomFeatures = (id) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.plans}/${id}/custom_features`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAccountCustomFeatures = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.domain + params.action,
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const GetAccountCustomFeatureById = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.domain + params.action,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddCustomFeature = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.plans + `/${data.plan_id}/custom_features`,
    data: data.payload
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateCustomFeature = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: urls.plans + `/${data.plan_id}/custom_features/${data.feature_id}`,
    data: data.payload
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const UpdateCustomFeatureEnabledValue  = (data) => {
  // PUT /v1/admin/customers/[customer ID]/account_custom_features/[ID]
  // PUT /v1/account_custom_features/[ID]
  // const target = true ? `${urls.admin.customers}/${data.customer_id}`: urls.domain
  // const url = target  + `/account_custom_features/${data.feature_id}`
  const requestOptions = {
    method: 'PUT',
    url: urls.domain + data.action,
    data: data.payload
  };

  return axios(requestOptions)
    .then(res => res.data);
}






export const DeleteCustomFeature = (data) => {
  const requestOptions = {
    method: 'DELETE',
    url: urls.plans + `/${data.plan_id}/custom_features/${data.feature_id}`,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetWebhooks = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.webhooks
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateWebhook = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.webhooks,
    data: {
      webhook: data
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateWebhook = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.webhooks}/${data.id}`,
    params: {
      webhook: data.data
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeleteWebhook = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.webhooks}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetWebhookEvents = (data) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.webhooks}/${data.id}/events`,
    params: data.params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetReminders = (query) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.reminders}${query}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const MarkRemsAsRead = () => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.reminders}/mark_as_read`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetNotifications = (query) => {
  const requestOptions = {
    method: 'GET',
    url: `${urls.admin.notifications}${query}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const MarkNotifsAsRead = () => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.admin.notifications}/mark_as_read`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateNotification = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.notifications,
    data: {
      notification: data
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateNotification = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.notifications}/${data.id}`,
    data: {
      notification: data.params
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveNotification = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.notifications}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetAnnouncements = (query , privileged_user = false) => {
  const url = privileged_user ? `${urls.admin.announcements}${query}` : `${urls.domain}/announcements${query}`
  const requestOptions = {
    method: 'GET',
    url
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateAnnouncement = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.announcements,
    data: {
      announcement: data
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateAnnouncement = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.announcements}/${data.id}`,
    data: {
      announcement: data.params
    }
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveAnnouncement = (id) => {
  const requestOptions = {
    method: 'DELETE',
    url: `${urls.admin.announcements}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const MarkAnnounsAsRead = () => {
  const requestOptions = {
    method: 'POST',
    url: `${urls.domain}/announcements/mark_as_read`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetMassEmails = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.mass_emails,
    params,
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateMassEmail = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.mass_emails,
    data,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const EnableAccessAPIDocs = () => {
  const requestOptions = {
    method: 'PUT',
    url: urls.admin.access_api_docs,
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const DisableAccessAPIDocs = () => {
  const requestOptions = {
    method: 'DELETE',
    url: urls.admin.access_api_docs,
  };

  return axios(requestOptions)
    .then(res => res.data);
}


export const GetZapierToken = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.api_key
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GenerateZapierToken = () => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.api_key
  };
  
  return axios(requestOptions)
    .then(res => res.data);
}

export const CreateErrorTicket = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.tickets,
    data: {
      ticket: data
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetErrorTickets = (params) => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.tickets,
    params
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const ChangeErrorTicket = (data) => {
  const requestOptions = {
    method: 'PUT',
    url: `${urls.admin.tickets}/${data.id}`,
    params: {
      ticket: data.params
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetPickUpSettings = () => {
  const requestOptions = {
    method: 'GET',
    url: urls.admin.pick_up_settings
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdatePickUpSettings = (data) => {
  const requestOptions = {
    method: 'POST',
    url: urls.admin.pick_up_settings,
    data: {
      settings: data
    }
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const RefreshFavicon = () => {
  const requestOptions = {
    method: 'PUT',
    url: urls.admin.refresh_favicon,
  };

  return axios(requestOptions)
    .then(res => res.data);
}
